import { useState, useEffect } from 'react';

const useUrlChange = () => {
  const [url, setUrl] = useState(window.location.href);

  useEffect(() => {
    const handleUrlChange = () => {
      setUrl(window.location.href);
    };

    window.addEventListener('popstate', handleUrlChange);
    window.addEventListener('pushState', handleUrlChange); // For pushState events
    window.addEventListener('replaceState', handleUrlChange); // For replaceState events

    return () => {
      window.removeEventListener('popstate', handleUrlChange);
      window.removeEventListener('pushState', handleUrlChange);
      window.removeEventListener('replaceState', handleUrlChange);
    };
  }, []);

  return url;
};

export default useUrlChange;
